<template></template>

<script>
import ApplePay from "./ApplePay";
import StripePay from "./StripePay";
import FreePay from "./FreePay";
export default {
  data: function () {
    return {
      method: this.isFree == 1 ? "free" : "stripe",
      payPalForm: {
        name: "",
        email: "",
        terms: "",
        marketing: 0,
      },
      applePayForm: {
        name: "",
        email: "",
        terms: "",
        marketing: 0,
      },
      product: null,
      bundle: null,
      price: null,
      copiedStatus: false,
      disableOnSubmit: false,
      paymentStatus: "processing",
      errorCode: false,
      errorMessage: false,
      showPayPalCheckout: false,
      showApplePayCheckout: false,
      stripePaymentRequestCount: 0,
      stripe: null,
      elements: null,

      voucher: false,
      voucherVerified: false,
      voucherCode: "",
      voucher: this.hasVoucher === 1 ? true : false,
      voucherData: this.voucherProp,
      discountPrice: this.selectedPrice,
    };
  },
  props: [
    "auth",
    "isFree",
    "hasVoucher",
    "buyReportUrl",
    "env",
    "selectedPrice",
    "stripeKey",
    "voucherUrl",
    "voucherProp",
    "removeVoucherUrl",
    "product_type",
    "product_bundle",
    "bundleHashid",
  ],

  mounted() {
    this.stripe = Stripe(this.stripeKey);

    // PayPal
    let self = this;

    const paypalButtonsComponent = paypal.Buttons({
        // Sets up the transaction when a payment button is clicked
        createOrder: function(data, actions) {
            return actions.order.create({
                purchase_units: [{
                    amount: {
                        value: self.discountPrice
                    }
                }],
                application_context: {
                    shipping_preference: "NO_SHIPPING"
                }
            });
        },

        // Finalize the transaction after payer approval
        onApprove: function(data, actions) {
            const captureOrderHandler = (details) => {
                $("#processing-modal-buy-report").modal({
                  backdrop: "static",
                  keyboard: false,
                });

                let postData = self.payPalForm;
                postData.method = "payPal";
                postData.pay_pal_charge_id = details.id;

                axios
                    .post(self.buyReportUrl, postData)
                    .then((response) => {
                        window.location = response.data.redirectUrl;
                    })
                    .catch((error) => {
                        self.handleError(error.response.data);
                    });
            };

            return actions.order.capture().then(captureOrderHandler);
        },

        // handle unrecoverable errors
        onError: (err) => {
            console.error('An error prevented the buyer from checking out with PayPal');
            self.handleError(err.response.data);
        }
    });

    paypalButtonsComponent
        .render("#paypal-button-container")
        .catch((err) => {
            console.error('PayPal Buttons failed to render');
        });
  },

  watch: {
    payPalForm: {
      handler() {
        this.togglePayPalCheckout();
      },
      deep: true,
    },
    applePayForm: {
      handler() {
        this.toggleApplePayCheckout();
      },
      deep: true,
    },
  },

  methods: {
    togglePayPalCheckout() {
      this.$validator.validateAll("payPalForm").then((result) => {
        this.showPayPalCheckout = result;
      });
    },

    toggleApplePayCheckout() {
      this.$validator.validateAll("applePayForm").then((result) => {
        this.showApplePayCheckout = result;
      });
    },

    validationClass(hasErrors) {
      return this.$parent.validationClass(hasErrors);
    },

    handleError(response) {
      let errorCode, message;

      if (typeof response.error == "object") {
        response = response.error;
      }

      if ("stripe_code" in response) {
        this.errorCode = response.stripe_code;
        if (this.errorCode == "0000") {
          this.paymentStatus = "error-general";
          return;
        }
        this.errorMessage = response.message;
        this.paymentStatus = "error-stripe";
        return;
      }

      if ("code" in response) {
        this.errorMessage = response.message;
        this.paymentStatus = "error-stripe";
        this.errorCode = "00402";
        return;
      }

      message = response.message;

      switch (message) {
        case "Validation failed":
          this.paymentStatus = "error-general";
          this.errorCode = "00422";
          break;
        case "Server Error":
          this.paymentStatus = "error-general";
          this.errorCode = "00501";
          break;
        case "There has been a server error trying to complete your request. If this error persists please contact support to report the issue.":
          this.paymentStatus = "error-general";
          this.errorCode = "00500";
          break;
        case "response_exception":
          this.paymentStatus = "error-general";
          this.errorCode = "00588";
          break;
        default:
          this.paymentStatus = "error-general";
          this.errorCode = "00599";
      }
    },
    closeModal() {
      this.disableOnSubmit = false;
      $("#processing-modal-buy-report").modal("hide");
      this.paymentStatus = "processing";
    },

    closeModalRedirectToContact() {
      $("#processing-modal-buy-report").modal("hide");
      window.location = "/contact";
    },

    applePayCompleted: function (ev) {
      $("#processing-modal-buy-report").modal({
        backdrop: "static",
        keyboard: false,
      });

      let postData = this.applePayForm;
      postData.method = "applePay";
      postData.payment_method = ev.paymentMethod;

      axios
        .post(this.buyReportUrl, postData)
        .then((response) => {
          window.location = response.data.redirectUrl;
          // Report to the browser that the payment was successful, prompting
          // it to close the browser payment interface.
          ev.complete("success");
        })
        .catch((error) => {
          this.handleError(error.response.data);
          // Report to the browser that the payment failed, prompting it to
          // re-show the payment interface, or show an error message and close
          // the payment interface.
          ev.complete("fail");
        });
    },

    // hasVoucher(type) {
    //     return this.voucher && this.voucherData.applies_to == type;
    // },
    showVoucherModal() {
      $("#voucher-modal").modal("show");
    },

    // NB, once the voucher is verified, we use that information to alter
    // the display of the prices on this view, but we when the form is
    // submitted, we don't tell the server what the final price is, we let
    // that calculation occur server side. This prevents someone POSTing
    // a fake price and getting a cheaper product.
    verifyVoucher() {
      let data = {
        voucher: this.voucherCode,
        product_type: this.product_type,
        product_bundle: this.product_bundle ? "true" : "false",
      };

      axios
        .post(this.voucherUrl, data)
        .then((response) => {
          this.voucherVerified = true;
          this.voucherData = response.data.voucher;

          if (this.voucherData !== undefined) {
            if (this.voucherData.discount_type == "percent") {
              this.discountPrice =
                this.selectedPrice -
                (this.selectedPrice * this.voucherData.discount_amount) / 100;
            } else {
              this.discountPrice =
                this.selectedPrice - this.voucherData.discount_amount;
            }

            this.discountPrice = Math.round(this.discountPrice * 100) / 100;
          }

          setTimeout(
            function () {
              $("#voucher-modal").modal("hide");
              this.voucherVerified = false;
              this.voucherCode = "";

              location.reload();
            }.bind(this),
            2000
          );
        })
        .catch((error) => {
          $("#voucher-modal").modal("hide");
          $("#voucher-not-valid-modal").modal("show");
        });
    },

    closeVoucherModal() {
      $("#voucher-modal").modal("hide");
      location.reload();
    },
    /**
     * Remove a voucher both server side (it's stored in the session data
     * for use in the next step), and within this Vue properties
     */
    removeVoucher() {
      axios
        .post(this.removeVoucherUrl)
        .then((response) => {
          this.voucherVerified = false;
          this.voucherCode = "";
          this.voucherData = false;
          this.voucher = false;

          location.reload();
        })
        .catch((error) => {
          alert("Problem removing voucher");
        });
    },
  },
  components: {
    ApplePay,
    StripePay,
    FreePay,
  },
};
</script>
